import { useMemo } from "react";
import { Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";

// Components
import Button from "../../components/Button/ButtonContainer";
import { CardContainer as Card } from "../../components/Card/CardContainer";
import { LoadingSection } from "../../components/LoadingSection/LoadingSection";
import Section from "../../components/Section/SectionContainer";

// CSS
import styles from "./videos.module.scss";

const Videos = (props) => {
    const {
        handleSelect,
        handleSelectPage,
        hasSelectedTags,
        isSearchActive,
        isSearching,
        shouldShowConfirmationModal,
        toggleConfirmationModal,
        totalPages,
        videosCollection,
    } = props;

    /**
     * Constants
     */

    const header = useMemo(() => {
        if (isSearchActive) return (
          <h1>search results</h1>
        );
        if (hasSelectedTags) return (
          <h1> tagged videos</h1>
        );
        return (
          <div>
            <h1>all videos</h1>
            <h6>The videos on this site are powered by Vimeo</h6>
          </div>

        );

    }, [hasSelectedTags, isSearchActive]);

    /**
     * End Hooks
     */

    function renderCards() {
        const list = videosCollection.map((video) => {
            return (

                <Card
                    data={video}
                    key={video.id}
                    onClick={() => handleSelect(video)}
                />
            );
        });
        if (list?.length && !isSearching) {
            return list;
        } else if (!list?.length && !isSearching) {
            return (
                <div className={styles.empty}>
                    <span>
                        We couldn't find any videos matching your search
                        request. Please try using a different search term.
                        <a href="/videos" rel="noreferrer" target="_self">
                            <Button className={styles.empty} text="reset filter" />

                        </a>

                    </span>
                </div>
            );
        }
    }

    function renderConfirmationModal() {
        return (
            shouldShowConfirmationModal && (
                <Modal
                    {...props}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    onHide={() => toggleConfirmationModal(false)}
                    size="lg"
                    show={shouldShowConfirmationModal}
                >
                    <Modal.Header closeButton />
                    <Modal.Body>
                        <h4>
                            Thank you for registering for Symphony Innovate 2021
                            [Digital]!
                        </h4>
                        <p>
                            Keep your eyes out for emails in the coming days and
                            weeks about the event, agenda, and more. If you have
                            any questions, please email{" "}
                            <a href="mailto:innovate@symphony.com">
                                innovate@symphony.com
                            </a>
                        </p>
                        <Button
                            onClick={() => toggleConfirmationModal(false)}
                            text="continue"
                            theme="green"
                        />
                    </Modal.Body>
                </Modal>
            )
        );
    }

    function renderLoading() {
        return (
            isSearching &&
            isSearchActive && (
                <div className={styles.loading}>
                    <LoadingSection />
                </div>
            )
        );
    }

    return (
        <Section classes={styles.videos}>
            {renderConfirmationModal()}
            {header}
            {renderLoading()}
            <div className={styles.grid}>{renderCards()}</div>
            <ReactPaginate
                breakLabel="..."
                className={styles.pagination}
                activeClassName={styles.active}
                disabledClassName={styles.disabled}
                onPageChange={handleSelectPage}
                pageCount={totalPages}
                pageRangeDisplayed={5}
                renderOnZeroPageCount={null}
            />
        </Section>
    );
};

export default Videos;
